import * as React from 'react'
import { SVGProps } from 'react'

const Mastercard = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width='22' height='13' viewBox='0 0 22 13' fill='none' {...props}>
    <g>
      <path d='M14.099 1.733H8.466v9.2h5.633v-9.2z' fill='#BFC6D6' />
      <path d='M9.046 6.334a5.841 5.841 0 012.235-4.6 5.85 5.85 0 100 9.2 5.842 5.842 0 01-2.235-4.6z' fill='#C9D0E3' />
      <path
        d='M20.747 6.334a5.85 5.85 0 01-9.467 4.6 5.852 5.852 0 000-9.201 5.851 5.851 0 019.467 4.6z'
        fill='#D8DDEA'
      />
    </g>
    <defs>
      <clipPath id='clip0'>
        <path fill='#fff' d='M.333.333h21.333v12H.333z' />
      </clipPath>
    </defs>
  </svg>
)

export default Mastercard
